module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": "Tema editor"
    }
  }, [_c('div', {
    staticClass: "cols cols-3"
  }, [_vm._l((_vm.edited_theme), function(v, k, i) {
    return [_c('div', {
      staticClass: "inputfield"
    }, [_c('label', [_vm._v(_vm._s(k))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": v
      },
      on: {
        "change": function($event) {
          return _vm.updateTheme(k, $event)
        }
      }
    })])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_c('filterbtn', {
    attrs: {
      "active": true
    }
  }, [_vm._v("UI example 1")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": false
    }
  }, [_vm._v("UI example 2")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": false
    }
  }, [_vm._v("UI example 3")])], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "UI examples"
    }
  }, [_c('btn', [_vm._v("Btn color1")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "2"
    }
  }, [_vm._v("Btn color2")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "3"
    }
  }, [_vm._v("Btn color3")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "4"
    }
  }, [_vm._v("Btn color4")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "4",
      "disabled": ""
    }
  }, [_vm._v("Btn disabled")]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "hay",
      "icon": "linearicons/arrow-left"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.var1),
      expression: "var1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.var1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.var1 = $event.target.value
      }
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b7b8e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ThemeMachine.vue
// module id = 612
// module chunks = 1